module.exports = __webpack_public_path__ + "static/img/4场景定制开发-on.d9de626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/4场景定制开发-on.png
// module id = MheS
// module chunks = 0